// Mix subscribed room tracks in the participant's browser, never on the platform server.
export async function createRoomCapture(room) {
  const Audio = window.AudioContext || window.webkitAudioContext;
  if (!Audio || !HTMLCanvasElement.prototype.captureStream) throw new Error("Ce navigateur ne prend pas en charge le mixage de la salle.");
  const audio = new Audio();
  const destination = audio.createMediaStreamDestination();
  const canvas = document.createElement("canvas"); canvas.width = 1280; canvas.height = 720;
  const context = canvas.getContext("2d");
  const sources = new Map(); let frame, stopped = false, output;
  const remove = (entry) => { entry.node?.disconnect(); if (entry.video) { entry.video.pause(); entry.video.srcObject = null; } };
  const cleanup = () => { if (stopped) return; stopped = true; cancelAnimationFrame(frame); sources.forEach(remove); sources.clear(); output?.getTracks().forEach((track) => track.stop()); void audio.close(); };
  try {
    await audio.resume();
    output = canvas.captureStream(20);
    destination.stream.getAudioTracks().forEach((track) => output.addTrack(track));
    const draw = () => {
      if (stopped) return;
      const active = new Set();
      const participants = [room.localParticipant, ...room.remoteParticipants.values()];
      for (const participant of participants) {
        for (const publication of participant.trackPublications.values()) {
          const track = publication.track?.mediaStreamTrack;
          if (!track || publication.isMuted || track.readyState === "ended" || !track.enabled) continue;
          active.add(track);
          if (!sources.has(track)) {
            const stream = new MediaStream([track]);
            if (track.kind === "audio") {
              const node = audio.createMediaStreamSource(stream); node.connect(destination); sources.set(track, { node });
            } else {
              const video = document.createElement("video"); video.muted = true; video.playsInline = true; video.srcObject = stream;
              void video.play().catch(() => {}); sources.set(track, { video, name: participant.name || participant.identity });
            }
          }
        }
      }
      for (const [track, entry] of sources) if (!active.has(track)) { remove(entry); sources.delete(track); }
      context.fillStyle = "#09090b"; context.fillRect(0, 0, canvas.width, canvas.height);
      const videos = [...sources.values()].filter((entry) => entry.video);
      const cols = Math.max(1, Math.ceil(Math.sqrt(videos.length))), rows = Math.max(1, Math.ceil(videos.length / cols));
      videos.forEach(({ video, name }, index) => {
        const width = canvas.width / cols, height = canvas.height / rows, x = (index % cols) * width, y = Math.floor(index / cols) * height;
        if (video.readyState >= 2) context.drawImage(video, x, y, width, height);
        context.fillStyle = "#18181b"; context.fillRect(x, y+height-28, width, 28);
        context.fillStyle = "#fafafa"; context.font = "16px sans-serif"; context.fillText(name, x+8, y+height-9, width-16);
      });
      if (!videos.length) { context.fillStyle = "#fafafa"; context.font = "24px sans-serif"; context.fillText("Conférence audio", 40, 60); }
      frame = requestAnimationFrame(draw);
    };
    draw();
    return { stream: output, close: cleanup };
  } catch (error) { cleanup(); throw error; }
}
